"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDialogStyles = void 0;
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var constants_1 = require("./constants");
var createDialogStyles = function (size) {
    if (size === void 0) { size = 'md'; }
    return ({
        container: react_1.css(__assign(__assign({ background: 'white', borderRadius: 12, padding: 24, boxShadow: "var(" + variables_1.Shadow.xl + ")" }, constants_1.SIZE_MAP[size]), { position: 'relative' })),
        close: react_1.css({
            position: 'absolute',
            top: 16,
            right: 16,
        }),
        titleNoIcon: react_1.css({
            marginRight: 40,
        }),
    });
};
exports.createDialogStyles = createDialogStyles;
